<template>
	<div>
		<div class="nav-bar">
			<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
				<el-tab-pane label="话费充值" name="first">
					<list1></list1>
				</el-tab-pane>
				<el-tab-pane label="快递发货" name="second" :lazy="true">
					<list2></list2>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
	import list1 from './PhoneCredit.vue'
	import list2 from './express.vue'
	export default {
		components: {
			list1,
			list2,
		},
		data() {
			return {
				activeName: "first",
			};
		},
		methods: {
			handleClick(tab, event) {
				// console.log(tab, event);
			},
		},
	}
</script>

<style>
</style>